module.exports = __webpack_public_path__ + "img/account-banner-bg.e68e18fa.png";